import { controlPanelShell as fdy } from "./foundry-parts.generated";
/**
 * @fileoverview SettingsSidebarSection — a labeled group of links inside the
 * SettingsSidebar, separated from other sections by Blueprint dividers.
 *
 * Foundry mapping: `control-panel-shell__sidebar-section`. The footer
 * variant (`__sidebar-footer-section`) is the same element with `footer=true`.
 */

import { Divider } from "@blueprintjs/core";
import type { ReactNode } from "react";

interface SettingsSidebarSectionProps {
  children: ReactNode;
  /** When true, this section is bottom-pinned (used for AIP/Help/User in Foundry). */
  footer?: boolean;
  /** When true, draws a Blueprint Divider above the section. */
  showDividerAbove?: boolean;
  className?: string;
}

export function SettingsSidebarSection({
  children,
  footer = false,
  showDividerAbove = false,
  className,
}: SettingsSidebarSectionProps) {
  return (
    <>
      {showDividerAbove && <Divider />}
      <ul
        data-testid="settings-sidebar-section"
        className={[
          footer ? fdy["sidebar-footer-section"] : fdy["sidebar-section"],
          footer ? "is-footer" : "",
          className,
        ].filter(Boolean).join(" ")}
      >
        {children}
      </ul>
    </>
  );
}
